import { Injectable } from '@angular/core';
import { CommunesService, CommuneTO } from '../../shared/api/generated/v2/incident';
import { EnvironmentService } from '../../shared/common/services/env.service';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CommuneService {

  private allCommunesCache$: Observable<CommuneTO[]>;

  constructor(private readonly communeService: CommunesService) {
    this.communeService.configuration.basePath =
      EnvironmentService.getEnvironment().incidentService;
  }

  public getCommunes(pageSize: number, pageIndex: number, filter: any) {
    return this.communeService.getCommunesForView(
      filter?.ags,
      filter?.town,
      filter?.contractType,
      filter?.netArea,
      pageIndex,
      pageSize,
      filter?.zipCode);
  }

  public getAllCommunes(): Observable<CommuneTO[]> {
    if (!this.allCommunesCache$) {
      this.allCommunesCache$ = this.communeService.getAllCommunes().pipe(
        shareReplay(1)
      );
    }
    return this.allCommunesCache$;
  }
}
